<template>
  <tr class="orgchart-secretary lines" v-if="anySiblingNodeHasAssistanceBool()">
    <td :colspan="100">
      <template v-if="typeof data.children !== 'undefined' || (data.codassis !== '' && data.assistActive)">
        <div class="downLine"></div>
        <div class="downLine"></div>
        <div class="downLine"></div>
        <div class="downLine test-secretary">
          <template v-if="data.codassis !== '' && data.assistActive">
            <div class="sideLine"></div>
            <div class="node" draggable="true">
              <div v-if="data.imgassispath !== ''"><img class="avatar" :src="'data:image/jpeg;base64,' + data.imgassispath"></div>
              <div v-else><img class="avatar" src="~static/images/employee/no_image.png"></div>
              <div class="name"><a @click="receivedOrgBodyDetail(data)" >{{ data.desc_assis }}</a></div>
            </div>
          </template>
        </div>
        <template v-if="typeof data.children !== 'undefined'">
          <template v-if="filterActive(data.children).length > 0">
            <div class="downLine"></div>
            <div class="downLine"></div>
            <div class="downLine"></div>
          </template>
        </template>
      </template>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'orgchart-secretary',
  props: [ 'data', 'rootNode', 'filterActive', 'siblingNodes', 'receivedOrgBodyDetail' ],
  methods: {
    anySiblingNodeHasAssistanceBool () {
      if (this.rootNode) {
        return this.data.codassis !== '' && this.data.assistActive
      } else {
        return this.siblingNodes.filter(function (siblingNode) {
          return siblingNode.codassis !== '' && siblingNode.assistActive
        }).length > 0
      }
    }
  }
}
</script>

<style lang="scss">
  .orgchart-secretary {
    .test-secretary {
      position: relative;
      .sideLine {
        position: absolute;
        top: 100%;
        left: 50%;
        /* width: 45px; */
        width: 55px;
        height: 1px;
        border-bottom: 2px solid #BDBDBD;
      }
      .node {
        position: absolute !important; 
        top: -260%;
        left: 55px;
        width: 130px;
        padding: 10px 0;
       
        .avatar {
          /* margin-left: 8px !important; */
        }
        >.name {
          font-family: 'cloud_lightlight';
          font-size: 14px;
          font-weight: 700;
          color: #212121;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// orgchartSecretary.vue?13998cf9